<template>
  <div>
    <el-container style="width: 900px; margin: 0 auto">
      <el-header style="margin: 0 auto">
        <div
          style="display: flex; justify-content: space-between; width: 350px"
        >
          <el-menu
            router
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="selectMenu"
          >
            <el-menu-item index="1-1" route="/main/price/priceHome">
              <span slot="title">报价器</span>
            </el-menu-item>
            <!-- <el-menu-item  index="1-2" route="/main/msg">
              <span slot="title">小信鸽</span>
            </el-menu-item> -->
            <el-menu-item index="1-3" route="/main/set">
              <span slot="title">设置</span>
            </el-menu-item>
          </el-menu>
          <div class="right-actions">
            <el-button type="text" @click="goHelp">帮助文档</el-button>
            <el-button type="text" @click="onReload">刷新</el-button>
            <el-button type="text" @click="onClose">退出</el-button>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
export default {
  name: "AppMain",
  data() {
    return {
      isCollapse: false,
      leftHidden: false,
      defaultPriceUrl: "",
      helpUrl:
        "https://www.yuque.com/jason-4wnje/euasut/dfha6wloy7wevmva?singleDoc# 《小蜜蜂报价器-使用说明书》",
    };
  },
  mounted() {},
  computed: {
    activeIndex() {
      return sessionStorage.getItem("activeIndex");
    },
  },
  methods: {
    selectMenu(index, indexPath) {
      sessionStorage.setItem("activeIndex", index);
      if (index == "1-2") {
        if (this.$store.getters.socket == null) {
          this.$store.commit("SOCKET_CONNECTION");
        }
      }
    },
    onClose() {
      this.$store.commit("WEB_DB", null);
      this.$store.commit("SET_SESSIONS", []);
      this.$store.commit("SET_SESSION", {});
      localStorage.removeItem("token");
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("activeIndex");
      this.$router.push({ name: "login" });
      this.$store.dispatch("socketClose");
    },
    onReload() {
      location.reload();
    },
    goHelp() {
      window.open(this.helpUrl, "_blank");
    },
  },
};
</script>

<style scoped></style>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  min-height: 400px;
  text-align: center;
}
.right-actions {
  display: flex;
  height: 60px;
  gap: 10px;
}
</style>
